import { useQuery } from "@tanstack/react-query";
import { get } from "~/Services/Request";

export const useGetSystemFiles = (path: string) => {
    return useQuery<SystemFile[]>({
        queryKey: ["/api/v1/admin/systemFiles?path=" + path],
        queryFn: () => get<SystemFile[]>("/api/v1/admin/systemFiles?path=" + encodeURIComponent(path)),
    });
};

export interface SystemFile {
    name: string;
    path: string;
    size: number;
    modifiedOn: string;
}
